import { ReactComponent as PhoneIcon } from '../../assets/phone.svg';
import { useSelector } from "react-redux";
import { OrganizationsState } from "../../reducers/OrganizationsSlice";
import { AppTester } from "../../../supporting";
import { useEffect, useMemo, useState } from "react";
import { ButtonWrapper } from "../../pages/explore/styles";
import { FInter, FlexBox, NavbarButtonFilled, NavbarButtonHollow, useBreakpoint } from "@brg/ui";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { LinkTo } from "../../constants/linkTo";
import { useTranslation } from "react-i18next";
import { API } from "@brg/api";
import styled from "styled-components";
import { LayoutConst } from "../../../core";
import scrollElementIntoView from "../../utils/scrollElementIntoView";
import {executeTypograf} from "../../utils/executeTypograf";

export const NeutralLink = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: inherit;
  :hover {
    color: inherit;
  }
`;

export const PhoneText = styled(FInter.SmallText)`
  color: #909090;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.34px;

  @media (max-width: 1600px) {
    font-size: 15px;
    line-height: 20px;
  }
`

const FixedWrapper = styled(FlexBox)<{ isDown?: boolean }>`
  position: fixed;
  bottom: ${({ isDown }) => isDown ? 0 : 28}px;
  transition: all 0.1ms;
  width: 100%;
  z-index: 99999;
  background: ${({ color }) => color};
  padding: 10px;
  button {
    width: 100%;
    max-width: initial;
    margin: 0;
  }
  a {
    margin-right: 0 !important;
  }

  @media (max-width: 1600px) {
    ${ButtonWrapper} {
      width: 100%;
      margin: 0;
    }
  }
`

const TeamInfoWrapper = styled(FlexBox)`
  button {
    white-space: nowrap;
    padding: 8px 24px !important;
    width: max-content;
    max-width: initial;
  }
`


const TeamInfo = ({ isFooter, isDown, phone: phoneProp }: { isFooter?: boolean, isDown?: boolean, phone?: string}) => {
  const storedTeam: any = useSelector((store: { organizations: OrganizationsState }): OrganizationsState => store.organizations.team);

  const isAgeytomesh = AppTester.isAgeytomesh();
  const isDvaDesign = AppTester.isDvaDesign();
  const isMobile = useBreakpoint(834);
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const is944 = useBreakpoint(944)
  const isTeamPreview = !!useRouteMatch([LinkTo.previewTeam]);
  const history = useHistory();
  const location = useLocation();
  const { i18n: { language } } = useTranslation();
  const [showCTA, setShowCTA] = useState(false)
  const [buttonIsAnchor, setButtonIsAnchor] = useState(false)
  const longreadVisible = useSelector((state: any) => state.vt.longreadVisible);
  const isForcedLanding = !!useRouteMatch('/brnd')?.isExact
  const isMainOrTeam = !!useRouteMatch(['/', '/teams/:id'])?.isExact
  const isMainOrLanding = isMainOrTeam || isForcedLanding;

  const team = useMemo(() => {
    if (storedTeam) {
      const translatedTeam = API.toLang(storedTeam, language)
      // @ts-ignore
      return {...translatedTeam, about: executeTypograf(translatedTeam?.about || ''), name: executeTypograf(translatedTeam?.name || '')}
    }
  }, [language, storedTeam])

  useEffect(() => {
    const changeCTAStyle = () => {
      const lastButton = document.querySelector('.lg-switch-button');
      const lastPost = document.querySelector('[data-rbd-draggable-context-id]:last-child')
      //@ts-ignore
      if ((window.scrollY <= lastButton?.offsetTop || window.scrollY > lastPost?.offsetTop - 500) && showCTA) {
        setShowCTA(false)
        //@ts-ignore
      } else if (lastButton && window.scrollY > lastButton?.offsetTop && !(window.scrollY > lastPost?.offsetTop - 500)) {
        setShowCTA(true)
      }
    };
    window.addEventListener('scroll', changeCTAStyle)
    return () => {
      window.removeEventListener('scroll', changeCTAStyle)
    }
  }, [showCTA])

  const {
    phone: phoneTeam,
    navButtons,
    additionalInfo: {
      color = 'transparent',
    } = {}
  } = team || {};

  const phone = phoneProp || phoneTeam

  const buttons = useMemo(() => {
    if (navButtons?.length) {
      return (
        <ButtonWrapper offsetLeft={!!phone?.length && !isMobile ? 24 : 0} offsetRight={isMobile ? 0 : is944 ? 24 : 8}>
          {navButtons?.map(({
            type,
            text: textRaw,
            textMobile,
            href,
            anchor
          }: any) => {
            const text = isMobile ? textMobile : textRaw;
            const hash = href?.split('#')?.[1] || anchor?.value;
            const isAnchor = !!hash;
            setButtonIsAnchor(isAnchor)
            const link = isAnchor ? `#${hash}` : href;

            if (['filled', 'anchor-filled'].includes(type)) {
              return (
                <>
                  {isAnchor ? (
                    <NavbarButtonFilled
                      fixedSize
                      disabled={isTeamPreview}
                      onClick={() => {
                        const element = document.querySelector(`[data-rbd-draggable-id="${hash}"]`)
                        if (element) {
                          scrollElementIntoView(element);
                        }
                      }}
                    >
                      {text}
                    </NavbarButtonFilled>
                  ) : (
                    <a href={link} target="_blank" rel="noreferrer">
                      <NavbarButtonFilled
                        fixedSize
                        disabled={isTeamPreview}
                      >
                        {text}
                      </NavbarButtonFilled>
                    </a>
                  )
                  }
                </>)
            }

            return (
              <>
                {isAnchor ? (
                  <NavbarButtonHollow disabled={isTeamPreview} fixedSize className={'hollow-button'} onClick={() => {
                    history.push(location.pathname + link)
                  }}>
                    {text}
                  </NavbarButtonHollow>
                ) : (
                  <a href={link}>
                    <NavbarButtonHollow disabled={isTeamPreview} fixedSize className={'hollow-button'}>
                      {text}
                    </NavbarButtonHollow>
                  </a>
                )}
              </>
            )
          })}
        </ButtonWrapper>
      )
    }
  }, [navButtons, is944, isMobile])

  const phoneButton = useMemo(() => {
    if (!!phone?.length) {
      return (
        <FlexBox offsetRight={is944 ? 16 : navButtons?.length ? 0 : 8}>
          {!is992 ? (
              <NeutralLink href={`tel:${phone}`}>
                <PhoneText>
                  {phone}
                </PhoneText>
              </NeutralLink>
          ) : (
            <NeutralLink href={`tel:${phone}`}>
              <PhoneIcon/>
            </NeutralLink>
          )}
        </FlexBox>
      )
    }
  }, [phone, is944, is992])

  if (!(isAgeytomesh || isDvaDesign) || !isMainOrLanding) {
    return null;
  }

  if (isFooter && !!navButtons?.length && isMobile && showCTA && longreadVisible) {
    return (
      <FixedWrapper color={color} isDown={isDown}>
        {buttons}
      </FixedWrapper>
    );
  }

  return (
    <TeamInfoWrapper>
      {phoneButton}
      {!!navButtons?.length && !isMobile && (!buttonIsAnchor || longreadVisible) && buttons}
    </TeamInfoWrapper>
  );
}

export default TeamInfo;import { ReactComponent as PhoneIcon } from '../../assets/phone.svg';
import { useSelector } from "react-redux";
import { OrganizationsState } from "../../reducers/OrganizationsSlice";
import { AppTester } from "../../../supporting";
import { useEffect, useMemo, useState } from "react";
import { ButtonWrapper } from "../../pages/explore/styles";
import { FInter, FlexBox, NavbarButtonFilled, NavbarButtonHollow, useBreakpoint } from "@brg/ui";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { LinkTo } from "../../constants/linkTo";
import { useTranslation } from "react-i18next";
import { API } from "@brg/api";
import styled from "styled-components";
import { LayoutConst } from "../../../core";
import scrollElementIntoView from "../../utils/scrollElementIntoView";
import {executeTypograf} from "../../utils/executeTypograf";

export const NeutralLink = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: inherit;
  :hover {
    color: inherit;
  }
`;

export const PhoneText = styled(FInter.SmallText)`
  color: #909090;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.34px;

  @media (max-width: 1600px) {
    font-size: 15px;
    line-height: 20px;
  }
`

const FixedWrapper = styled(FlexBox)<{ isDown?: boolean }>`
  position: fixed;
  bottom: ${({ isDown }) => isDown ? 0 : 28}px;
  transition: all 0.1ms;
  width: 100%;
  z-index: 99999;
  background: ${({ color }) => color};
  padding: 10px;
  button {
    width: 100%;
    max-width: initial;
    margin: 0;
  }
  a {
    margin-right: 0 !important;
  }

  @media (max-width: 1600px) {
    ${ButtonWrapper} {
      width: 100%;
      margin: 0;
    }
  }
`

const TeamInfoWrapper = styled(FlexBox)`
  button {
    white-space: nowrap;
    padding: 8px 24px !important;
    width: max-content;
    max-width: initial;
  }
`


const TeamInfo = ({ isFooter, isDown, phone: phoneProp }: { isFooter?: boolean, isDown?: boolean, phone?: string}) => {
  const storedTeam: any = useSelector((store: { organizations: OrganizationsState }): OrganizationsState => store.organizations.team);

  const isAgeytomesh = AppTester.isAgeytomesh();
  const isDvaDesign = AppTester.isDvaDesign();
  const isMobile = useBreakpoint(834);
  const is992 = useBreakpoint(LayoutConst.screen.m);
  const is944 = useBreakpoint(944)
  const isTeamPreview = !!useRouteMatch([LinkTo.previewTeam]);
  const history = useHistory();
  const location = useLocation();
  const { i18n: { language } } = useTranslation();
  const [showCTA, setShowCTA] = useState(false)
  const [buttonIsAnchor, setButtonIsAnchor] = useState(false)
  const longreadVisible = useSelector((state: any) => state.vt.longreadVisible);
  const isForcedLanding = !!useRouteMatch('/brnd')?.isExact
  const isMainOrTeam = !!useRouteMatch(['/', '/teams/:id'])?.isExact
  const isMainOrLanding = isMainOrTeam || isForcedLanding;

  const team = useMemo(() => {
    if (storedTeam) {
      const translatedTeam = API.toLang(storedTeam, language)
      // @ts-ignore
      return {...translatedTeam, about: executeTypograf(translatedTeam?.about || ''), name: executeTypograf(translatedTeam?.name || '')}
    }
  }, [language, storedTeam])

  useEffect(() => {
    const changeCTAStyle = () => {
      const lastButton = document.querySelector('.lg-switch-button');
      const lastPost = document.querySelector('[data-rbd-draggable-context-id]:last-child')
      //@ts-ignore
      if ((window.scrollY <= lastButton?.offsetTop || window.scrollY > lastPost?.offsetTop - 500) && showCTA) {
        setShowCTA(false)
        //@ts-ignore
      } else if (lastButton && window.scrollY > lastButton?.offsetTop && !(window.scrollY > lastPost?.offsetTop - 500)) {
        setShowCTA(true)
      }
    };
    window.addEventListener('scroll', changeCTAStyle)
    return () => {
      window.removeEventListener('scroll', changeCTAStyle)
    }
  }, [showCTA])

  const {
    phone: phoneTeam,
    navButtons,
    additionalInfo: {
      color = 'transparent',
    } = {}
  } = team || {};

  const phone = phoneProp || phoneTeam

  const buttons = useMemo(() => {
    if (navButtons?.length) {
      return (
        <ButtonWrapper offsetLeft={!!phone?.length && !isMobile ? 24 : 0} offsetRight={isMobile ? 0 : is944 ? 24 : 8}>
          {navButtons?.map(({
            type,
            text: textRaw,
            textMobile,
            href,
            anchor
          }: any) => {
            const text = isMobile ? textMobile : textRaw;
            const hash = href?.split('#')?.[1] || anchor?.value;
            const isAnchor = !!hash;
            setButtonIsAnchor(isAnchor)
            const link = isAnchor ? `#${hash}` : href;

            if (['filled', 'anchor-filled'].includes(type)) {
              return (
                <>
                  {isAnchor ? (
                    <NavbarButtonFilled
                      fixedSize
                      disabled={isTeamPreview}
                      onClick={() => {
                        const element = document.querySelector(`[data-rbd-draggable-id="${hash}"]`)
                        if (element) {
                          scrollElementIntoView(element);
                        }
                      }}
                    >
                      {text}
                    </NavbarButtonFilled>
                  ) : (
                    <a href={link} target="_blank" rel="noreferrer">
                      <NavbarButtonFilled
                        fixedSize
                        disabled={isTeamPreview}
                      >
                        {text}
                      </NavbarButtonFilled>
                    </a>
                  )
                  }
                </>)
            }

            return (
              <>
                {isAnchor ? (
                  <NavbarButtonHollow disabled={isTeamPreview} fixedSize className={'hollow-button'} onClick={() => {
                    history.push(location.pathname + link)
                  }}>
                    {text}
                  </NavbarButtonHollow>
                ) : (
                  <a href={link}>
                    <NavbarButtonHollow disabled={isTeamPreview} fixedSize className={'hollow-button'}>
                      {text}
                    </NavbarButtonHollow>
                  </a>
                )}
              </>
            )
          })}
        </ButtonWrapper>
      )
    }
  }, [navButtons, is944, isMobile])

  const phoneButton = useMemo(() => {
    if (!!phone?.length) {
      return (
        <FlexBox offsetRight={is944 ? 16 : navButtons?.length ? 0 : 8}>
          {!is992 ? (
              <NeutralLink href={`tel:${phone}`}>
                <PhoneText>
                  {phone}
                </PhoneText>
              </NeutralLink>
          ) : (
            <NeutralLink href={`tel:${phone}`}>
              <PhoneIcon/>
            </NeutralLink>
          )}
        </FlexBox>
      )
    }
  }, [phone, is944, is992])

  if (!(isAgeytomesh || isDvaDesign) || !isMainOrLanding) {
    return null;
  }

  if (isFooter && !!navButtons?.length && isMobile && showCTA && longreadVisible) {
    return (
      <FixedWrapper color={color} isDown={isDown}>
        {buttons}
      </FixedWrapper>
    );
  }

  return (
    <TeamInfoWrapper>
      {phoneButton}
      {!!navButtons?.length && !isMobile && (!buttonIsAnchor || longreadVisible) && buttons}
    </TeamInfoWrapper>
  );
}

export default TeamInfo;